export function checkDupes (item, CTArr) {
  // Checking duplicate node entry.
  return CTArr.find(ct => ct?.entity?.nid === item?.entity?.nid) === undefined
}
